<template lang="html">
  <div ref="specialSlider" class="special-slider avoid-page-break" v-bind:class="{ smallSpecialSlider:smallThermometer }">
    <ul v-if="!smallThermometer">
      <li v-for="( item, index ) in items" :key="index">{{ modifyPercentage(item.percentage) }}</li>
    </ul>
    <div v-if="smallThermometer" class="lower-text-section">
      <p style="text-align:left">CCC</p>
      <p style="text-align:right">AAA</p>
    </div>
    <el-slider disabled :show-tooltip="false" ref="slider" v-bind:class="{ smallThermometer:smallThermometer, hideButton:hideButton }" v-model="value"></el-slider>
    <!-- <p v-if="smallThermometer" ref="valueText" class="value-text">{{ this.internal_calification_name }}</p> -->
    <ul v-if="!smallThermometer">
      <li v-for="( item, index ) in items" :key="index">{{ item.name }}</li>
    </ul>
    <div v-if="smallThermometer" class="special-letter-section">
      <div ref="specialLetterContainer" class="special-letter-container">
        <p class="special-letter">{{calification_name}}+</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    graph_data: {},
    calification_name: String,
    smallThermometer: false
  },
  data() {
    return {
      value: 0,
      internal_calification_name: String,
      hideButton: false,
      items: [],
      colors: [
        "#C14027",
        "#EA805A",
        "#EA8E5A",
        "#FBBF8F",
        "#BBD89B",
        "#94C75A",
        "#60A114"
      ]
    };
  },
  computed: {},
  watch: {
    value: "changeColor"
  },
  methods: {
    updateComponent() {
      // if the is no data at all don´t display anything
      if (Object.keys(this.graph_data).length < 1) {
        this.$el.style.display = "none";
        console.log("Don´t display the special slider");
      }
      // Show the button data if there is data for the button
      if (this.graph_data.value) {
        this.value = this.graph_data.value * 1000 / 10;
      }
      // Hide the button is there is no data for the button
      if (!this.graph_data.value) {
        this.hideButton = true;
      }
      // Modify the button value to a percentage version
      let num = this.value;
      if (num % 1 != 0) {
        num = num.toFixed(2);
        this.value = Number(num);
      }
      // Assign the data of the ul v-for data
      this.items = this.graph_data.items;
    },
    changeColor() {
      let button = this.$refs.slider.$el.querySelector(".el-slider__button");
      let section = Math.floor((this.value - 1) / 14);
      if (this.value > 80) {
        section = Math.floor((this.value - 2) / 14);
      }
      if (section == -1) {
        section = 0;
      }
      if (section >= 6) {
        section = 6;
      }
      button.style.backgroundColor = this.colors[section];
      let valueText = this.$refs.valueText;
      if (valueText) {
        valueText.style.color = this.colors[section];
      }
    },
    modifyPercentage(keyValue) {
      keyValue = keyValue * 1000 / 10;
      if (keyValue % 1 != 0) {
        let num = keyValue;
        num = num.toFixed(2);
        keyValue = Number(num);
      }
      return keyValue + "%";
    }
  },
  beforeMount() {},
  mounted() {
    this.updateComponent();
    if (this.smallThermometer) {
      if (Object.keys(this.graph_data).length < 1) {
      console.log(this.$el.parentElement.parentElement.querySelector(".specialSliderTittle"));
      let tittle = this.$el.parentElement.parentElement.querySelector(".specialSliderTittle");
      tittle.style.display = "none";
      }
      this.$refs.slider.$el.style.width = "360px";
      this.$refs.slider.$el.querySelector(".el-slider__runway").style.margin =
        "0px";
      this.$refs.slider.$el.querySelector(".el-slider__runway").style.height =
        "6px";
      this.$refs.specialSlider.style.margin = "0px";
      this.internal_calification_name = this.calification_name;
      let special_letter_container = this.$refs.specialLetterContainer;
      special_letter_container.style.left = this.value + "%";
    }
  }
};
</script>

<style media="screen">
.hideButton .el-slider__button-wrapper {
  display: none;
}
.el-slider__runway.disabled .el-slider__bar {
  background-color: rgba(0, 0, 0, 0);
}
.el-slider__runway {
  background: -webkit-linear-gradient(
    left,
    #c14027,
    #c14027 calc(14.2857142857% * 1),
    #ea805a,
    #ea805a calc(14.2857142857% * 1),
    #ea805a,
    #ea805a calc(14.2857142857% * 2),
    #ea8e5a,
    #ea8e5a calc(14.2857142857% * 2),
    #ea8e5a,
    #ea8e5a calc(14.2857142857% * 3),
    #fbbf8f,
    #fbbf8f calc(14.2857142857% * 3),
    #fbbf8f,
    #fbbf8f calc(14.2857142857% * 4),
    #bbd89b,
    #bbd89b calc(14.2857142857% * 4),
    #bbd89b,
    #bbd89b calc(14.2857142857% * 5),
    #94c75a,
    #94c75a calc(14.2857142857% * 5),
    #94c75a,
    #94c75a calc(14.2857142857% * 6),
    #60a114,
    #60a114 calc(14.2857142857% * 6),
    #60a114,
    #60a114 calc(14.2857142857% * 7)
  );
}
.el-slider__button {
  position: relative;
  top: 1px;
  width: 11px;
  height: 11px;
  border: 3px solid rgba(227, 236, 255, 1) !important;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2),
    0 3px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: auto !important;
}
.el-slider__button-wrapper {
  cursor: auto !important;
}
.el-slider__bar {
  background-color: rgba(0, 0, 0, 0);
}
.el-slider__runway {
  height: 10px;
  border-radius: 5px;
}
.smallSpecialSlider {
  width: 400px !important;
  /* background-color: lightgoldenrodyellow; */
  /* margin: 0 auto !important; */
  margin-left: 111px !important;
  /* right: 2em; */
}
.smallThermometer {
  display: block;
  margin: 0px auto;
  margin-top: 6px;
  /* margin-left: 128px; */
  /* float: right; */
}
.smallThermometer .el-slider__button {
  top: -1px;
  width: 14px;
  height: 14px;
}
</style>

<style lang="css" scoped>
.special-letter-section {
  /* background-color: lightblue; */
  height: 24px;
  position: relative;
  top: 12px;
  width: 360px;
  display: block;
  margin: 0 auto;
  /* margin-left: 105px; */
}
.special-letter-container {
  position: absolute;
  background-color: white;
  border-radius: 2px;
  left: calc(0%);
  transform: translate(-50%, 0);
  text-align: center;
  padding: 0px;
  font-size: 10px;
}
.special-letter {
  margin: 0;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.lower-text-section {
  display: block;
  height: 30px;
  position: relative;
  top: 7px;
  width: 380px;
  margin: 0 auto;
}
.lower-text-section p {
  display: inline-block;
  margin: 0;
  font-size: 10px;
  width: 49.2%;
}
.riesgo-text {
  width: 360px;
  margin: 0px !important;
  font-size: 10px;
  float: right;
  color: #848484;
  position: relative;
  top: 2px;
}
.value-text {
  width: 360px;
  margin: 0px !important;
  display: block;
  float: right;
  margin-top: 10px !important;
  text-align: right;
  font-weight: 600;
}
.special-slider {
  max-width: 768px;
  margin: 30px auto;
  width: 81%;
  text-align: center;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: #848484;
}
li {
  float: left;
  width: 14.2857142857%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin: 2px 0;
}
li a {
  display: block;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/SpecialSlider.vue